import { render, staticRenderFns } from "./CobroFacturasCE.vue?vue&type=template&id=d39343c6&"
import script from "./CobroFacturasCE.vue?vue&type=script&lang=js&"
export * from "./CobroFacturasCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports